import { DashboardWalletCounterData } from "@lib/types/Dashboard";
import { StyledListItem } from "./index.styled";
import { Typography } from "antd";

type Props = {
  data: DashboardWalletCounterData<any>;
};
const ListItem = ({ data }: Props) => {
  return (
    <StyledListItem>
      <div className="earning-wrapper">
        <div style={{ backgroundColor: data.color }} className="dot-icon" />
        {data?.icon && (
          <img src={data.icon} style={{ height: "15px", marginRight: 10 }} />
        )}
        <div className="earning-text">{`${data.name}`}</div>
      </div>
      {data.valueText ? (
        data.valueText
      ) : (
        <Typography.Text strong>{data.value}</Typography.Text>
      )}
    </StyledListItem>
  );
};

export default ListItem;
